import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Box, Container, Paragraph } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import BFF from '../../../../services/BFF';
import Card, { Content, Title } from '../../../Card';
import Form from '../Form';
import NewCase from '../NewCase';
import Section from '../Section';
import ServerError from '../ServerError';

const EmailUs = ({ setSubmitting }) => {
  const [newCase, setNewCase] = useState();
  const [serverError, setServerError] = useState();
  const { query } = useRouter();

  return (
    <Box
      bg="greys.porcelain"
      pt="10"
      data-testid="CONTACT_US_FORM"
      id="contact-us-form"
    >
      <Container>
        <Section>
          <Card>
            <Title px="10" py="6">
              <Box fontSize={['2xl', null, '3xl']}>Email us</Box>
            </Title>
            <Content px="10" pb="10">
              {serverError && <ServerError error={serverError.message} />}
              {newCase ? (
                <NewCase newCase={newCase} />
              ) : (
                <Box>
                  <Paragraph>
                    Get in touch with our team if you have questions about your
                    Qantas Holidays booking, or would like to give feedback
                    about your experience and more.
                  </Paragraph>
                  <Form
                    data={{
                      title: query.title,
                      givenNames: query.given_names,
                      lastName: query.last_name,
                      emailAddress: query.email,
                      phone: query.phone,
                      bookingReference: query.booking_reference,
                      qantasFrequentFlyerNumber:
                        query.qantas_frequent_flyer_number,
                      message: query.message,
                    }}
                    onSubmit={(data) => {
                      setSubmitting(true);
                      setServerError(undefined);

                      BFF.contactUs()(data)
                        .then(setNewCase)
                        .catch((error) => setServerError(error))
                        .then(() => setSubmitting(false));
                    }}
                  />
                </Box>
              )}
            </Content>
          </Card>
        </Section>
      </Container>
    </Box>
  );
};

EmailUs.propTypes = {
  setSubmitting: PropTypes.func.isRequired,
};

export default EmailUs;
